module.exports = __webpack_public_path__ + "img/chrome_big.17fc2824.png";